import React, { useContext } from 'react';
import { RicosContext, EditorContext, ModalContext } from 'ricos-context';
import { POLL_TYPE } from '../../types.js';
import { pollModals } from '../../consts.js';
import { PollPresetSelector } from '../settings/preset-selector/PollPresetSelector.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import 'ricos-schema';
import 'lodash';
import 'wix-rich-content-ui-components';
import '../../helpers-d59c72d9.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../../dataHooks.js';
import '../../assets/icons/RemoveIcon.js';
import '../../assets/icons/ListPollIcon.js';
import '../../assets/icons/WithImagePollIcon.js';
import '../../assets/icons/GridPollIcon.js';

var css_248z = ".shRBN,.y5ALB{position:relative}.shRBN{z-index:1}@supports not (contain:inline-size){@media only screen and (min-width:940px){.s5-9y{width:400px}}}@container (min-width: 940px){.s5-9y{width:400px}}";
var styles = {"container":"y5ALB","editorClickable":"shRBN","insertModalWrapper":"s5-9y"};
styleInject(css_248z);

const PollsInsertModal = ({ componentData, showCloseButton }) => {
  const { t, isMobile } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext) || {};
  const addBlockWithFocus = (insertBlock) => setTimeout(() => insertBlock(), 50);
  const closeModal = () => {
    modalService.closeModal(pollModals.insert);
  };
  const onPollAdd = (poll) => {
    const editorCommands = getEditorCommands();
    const insertPoll = () => editorCommands == null ? void 0 : editorCommands.insertBlockWithBlankLines(POLL_TYPE, poll);
    addBlockWithFocus(insertPoll);
    closeModal();
  };
  return /* @__PURE__ */ React.createElement("div", { className: styles.insertModalWrapper }, /* @__PURE__ */ React.createElement(
    PollPresetSelector,
    {
      componentData,
      t,
      isMobile,
      onPollAdd,
      closeModal,
      showCloseButton
    }
  ));
};

export { PollsInsertModal as default };
//# sourceMappingURL=InsertModal.js.map
